import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { orpc } from "@/lib/orpc";
import { FamilyContactsCard } from "./-components/contacts/family-contacts-card";
import { LegacyEmergencyContactCard } from "./-components/contacts/legacy-emergency-contact-card";
import { NotOnListSection } from "./-components/care-network/not-on-list-section";
import { OutsideAccessCard } from "./-components/care-network/outside-access-card";
import { PortalDialogs } from "./-components/portal/portal-dialogs";
import { ResidentLoginCard } from "./-components/portal/resident-login-card";
import { useFamilyPortal } from "./-components/portal/use-family-portal";

export const Route = createFileRoute("/_authenticated/_care/residents/$residentId/family")({
  component: FamilyTab,
});

function FamilyTab() {
  const { residentId } = Route.useParams();
  const { data: resident } = useSuspenseQuery(
    orpc.care.residents.get.queryOptions({ input: { residentId } }),
  );
  const portal = useFamilyPortal(residentId, resident.facilityId);
  return (
    <div className="space-y-6">
      <LegacyEmergencyContactCard resident={resident} />
      <FamilyContactsCard
        residentId={residentId}
        residentName={`${resident.firstName} ${resident.lastName}`}
        facilityId={resident.facilityId}
        portal={portal}
      />
      <NotOnListSection residentId={residentId} facilityId={resident.facilityId} portal={portal} />
      <OutsideAccessCard residentId={residentId} facilityId={resident.facilityId} />
      <ResidentLoginCard portal={portal} facilityId={resident.facilityId} />
      <PortalDialogs portal={portal} />
    </div>
  );
}
